import React, { useContext } from 'react'
import HomePageCSS from './HomePage.css'
import pic from '../../images/feeldamagic.jpg'
import mahikastore from '../../images/mahikastore.jpg'
import mahikathings from '../../images/mahikathings.jpg'
import { Link } from 'react-router-dom'
import { RecommendationContext } from '../../context/RecommendationContext'; 
import { StoreContext } from '../../context/StoreContext'

export default function HomePage() {

  const { recommendation } = useContext(RecommendationContext);
  const {url} = useContext(StoreContext);

  return (
    <>
      <div className='header'>
        <div className="header-content">
        <h2>Order your favorite drinks here</h2>
        <button><Link style={{ textDecoration: 'none'}} to = "/Menu">View Menu</Link></button>
        </div>
      </div>

      {/* {recommendation && (
          <div className='recommendation'>
            <h3>Recommended Drink for You:</h3>
            <p>{recommendation.name}</p>
            <img src={`${url}/images/${recommendation.image}`} alt=""/>
            <p>Sugar Level: {recommendation.sugar}</p>
          </div>
        )} */}

      <div className='cover'>
        <div className='cover-content'>
          <div className='cover-content-left'>
            <div className='cover-content-text'>
            <h2>Are you ready to embark on a delightful journey of flavor and comfort? <br/>
              Look no further than our exquisite milk tea creations!</h2>
             <img src={pic} className={HomePageCSS.pic}/>
            </div>
          </div>
          <div className='cover-content-right'>
          {recommendation && (
          <div className='recommendation'>
            <h3>Recommended Drink for You:</h3>
            <p>{recommendation.name}</p>
            <img src={`${url}/images/${recommendation.image}`} alt=""/>
            <p>Sugar Level: {recommendation.sugar}</p>
          </div>
        )}
            {/* <img src={mahikastore} className={HomePageCSS.mahikastore}/> */}
            <h2>Whether you’re a seasoned milk tea enthusiast or a curious newcomer, <br/>
             we’ve got something special brewing just for you.</h2>
            <img src={mahikathings} className={HomePageCSS.mahikathings}/>
          </div>
          
        </div>
      </div>
    </>
  )
}
